import { useAuthContext } from 'src/Components/AuthContext';
import { AuthTokenType } from 'src/graphql/__generated__/globalTypes';
import { Button } from 'src/shadcn/components/ui/button';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogHeader,
  DialogTrigger,
  DialogDescription,
  DialogFooter,
} from 'src/shadcn/components/ui/dialog';
import { SidebarFooter } from 'src/shadcn/components/ui/sidebar';
import { SidebarSettingsMenuEmployeeLogoutButton } from '../SidebarSettingsMenu/SidebarSettingsMenuEmployeeLogoutButton';
import { useSidebarSetingsMenuEmployeeLogoutButtonState } from '../SidebarSettingsMenu/useSidebarSetingsMenuEmployeeLogoutButtonState';

export const DashboardSidebarFooter = () => {
  const authContext = useAuthContext();
  const employeeLogoutButtonState =
    useSidebarSetingsMenuEmployeeLogoutButtonState();
  return (
    <SidebarFooter>
      <Dialog>
        <DialogTrigger asChild>
          <Button variant={'link'}>Log out</Button>
        </DialogTrigger>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Are you sure you want to log out?</DialogTitle>
            <DialogDescription>
              When you log out, we will redirect to the shop login screen. Other
              employees will be able to log into their account from there.
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            {authContext.user?.authTokenType === AuthTokenType.ADMIN ? (
              <Button
                variant={'destructive'}
                onClick={() => {
                  authContext.logout();
                }}
              >
                <span>Log out</span>
              </Button>
            ) : (
              <SidebarSettingsMenuEmployeeLogoutButton
                state={employeeLogoutButtonState}
              />
            )}
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </SidebarFooter>
  );
};
